export const ELEMENT_LOGO = 'logo';
export const ELEMENT_MODAL_LOGO = 'modalLogo';
export const ELEMENT_MODAL_CTA = 'modalCTA';
export const ELEMENT_FOOTER_CTA = 'footerCTA';

export const ELEMENT_EMBED = 'embed';
export const ELEMENT_ALT_EMBED = 'alt_embed';
export const ELEMENT_ADD_EMBED = 'add_embed';
export const ELEMENT_LINK_OUT = 'link_out';
export const ELEMENT_ZOOM_LINK_OUT = 'zoom_link_out';
export const ELEMENT_ALT_ZOOM_LINK_OUT = 'alt_zoom_link_out';

// On event view
export const ELEMENT_ALT_EMBED_EVENT = 'altEmbed';
export const ELEMENT_LINK_OUT_EVENT = 'linkOut';
export const ELEMENT_ZOOM_LINK_OUT_EVENT = 'zoomLinkOut';

export const SINGLE_SESSION = 'singleSession';
export const MULTI_SESSION = 'multiSession';

export const PAGE_STATE_PRE_EVENT = 'preEvent';
export const PAGE_STATE_CHECK_IN = 'checkIn';
export const PAGE_STATE_DURING_EVENT = 'duringEvent';
export const PAGE_STATE_DURING_EVENT_MULTI_SESSION = 'multiSessionDuringEvent';

export const EVENT_CUTOFF_TIME_MINUTES = 30;

export const PAGE_STATES = [
    PAGE_STATE_PRE_EVENT,
    PAGE_STATE_CHECK_IN,
    PAGE_STATE_DURING_EVENT,
    PAGE_STATE_DURING_EVENT_MULTI_SESSION,
];

/**
 * VERSION CHANGELOG
 *
 * 1.0.0
 * MVP
 *
 * 1.1.0
 * Added inline text editing
 *  - Renamed constant ELEMENT_MODAL_COUNTDOWN to V2 to apply changes retroactively
 */

export const PAYLOAD_VERSION_CURRENT = '1.1.0';

// Types of content you can have in the "embed area"
export const CONTENT_TYPE_EMBED = 'embed';
export const CONTENT_TYPE_EMBED_ZOOM = 'zoom';
export const CONTENT_TYPE_LINK_OUT = 'link_out';

export const VIRTUAL_PURIFY_CONFIG = {
    USE_PROFILES: { html: true },
    ADD_TAGS: ['iframe'],
    ADD_ATTR: ['width', 'height', 'allow', 'allowfullscreen'],
    FORBID_TAGS: ['script'],
    ALLOW_DATA_ATTR: false,
    ALLOWED_URI_REGEXP: /^(?:(?:(?:f|ht)tps?):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i,
};

export const EMBED_TYPE_ZOOM = 'zoom';
export const EMBED_TYPE_VIMEO = 'vimeo';
export const EMBED_TYPE_RAW = 'raw';
export const EMBED_TYPE_INTROVOKE = 'introvoke';
export const EMBED_TYPE_SPLASH_STUDIO = 'splashStudio';
export const EMBED_TYPE_CUSTOM = 'custom';
export const EMBED_TYPE_EMPTY = 'select';

export const SPLASH_STUDIO_MODAL_ID = 'splashStudioHostLinkModal';
export const EMBED_MODAL_ID = 'embedModal';
export const SPLASH_STUDIO_SETTINGS_MODAL_ID = 'splashStudioSettingsModal';

export const TYPE_VIRTUAL_EVENT_MULTISESSION = '2';

export const VIRTUAL_SETTINGS_ERROR_MESSAGE = 'Settings request failed. Please try again in a few minutes.';
export const CHECK_IN_TOKEN_ERROR_MESSAGE = 'The check-in service is not available. Please try again in a few minutes.';
